import React from "react";
import moment from "moment";
import bannerBg from "../../../../Assets/Images/banner-bg.png";
import bannerImg from "../../../../Assets/Images/banner-img.jpeg";
import { WEB_URL } from "../../../../redux/actions/config";
import "./style.css";

const TopBanner = ({ data, eventProps }) => {
  return (
    <div class="program-banner">
      <div class="content">
        <div class="graphic"><img src={bannerBg} alt="bannerBg" /></div>
        <div class="block">
          <h1>Welcome to {data?.event_name}</h1>
          <div class="text">{moment(data?.start_date).format("DD MMM YYYY")} - {moment(data?.end_date).format("DD MMM YYYY")}</div>
        </div>
      </div>
      <div class="imgBlock">
        <img src={bannerImg} alt="bannerImg" />
      </div>
      <div class="narc-navbar">
        <div class="menu-slot">
          <ul>
            {eventProps?.rules_and_faq && <li class="menubar"><a href={`${WEB_URL}/champions/${data?.event_code}/rules`} className="fw-semibold" target="_blank">Rules &amp; FAQs</a></li>}
            {eventProps?.leaderboard && <li class="menubar"><a href={`${WEB_URL}/champions/leaderboard`} className="fw-semibold" target="_blank">Leaderboard</a></li>}
            {eventProps?.awards_and_certificates && <li class="menubar"><a href={`${WEB_URL}/champions/${data?.event_code}/prize`} className="fw-semibold" target="_blank">Prizes</a></li>}
            <li class="menubar"><a href={`${WEB_URL}/request-support`} className="fw-semibold" target="_blank">Support</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
